<template>
<div>
  <b-navbar-nav class="mr-auto">
    <b-nav-item use-router :to="{name: 'analyseAndonKanban'}" exact>Analyse Andon Kanban</b-nav-item>
    <b-nav-item-dropdown
      id="dropdown-scan-document"
      text="Outils"
      toggle-class="nav-link-custom"
      right>
      <b-dropdown-item use-router :to="{name: 'kanbanBe'}">
        Kanban BE/Commerce/I.T.
      </b-dropdown-item>
      <b-dropdown-item use-router to="/reception/historique-lead-time">
        Graph Leadtime Récéption
      </b-dropdown-item>
      <b-dropdown-item use-router :to="{name: 'ProductAndonMethod'}">
        Produits Chauds
      </b-dropdown-item>
      <b-dropdown-item use-router :to="{name: 'RankingABC'}">
        Ranking Produits ABC
      </b-dropdown-item>
      <b-dropdown-item href="https://erpdocument.aiotools.ovh">
        ERP Document
      </b-dropdown-item>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
      id="dropdown-scan-kanban"
      text="Scan Kanban"
      toggle-class="nav-link-custom"
      right
    >
      <b-dropdown-group id="dropdown-group-1" header="Boucle Externe">
        <b-dropdown-item use-router to="/scankanban/Attente commande">En attende de commande</b-dropdown-item>
        <b-dropdown-item use-router to="/scankanban/Commandé">Commandé</b-dropdown-item>
        <b-dropdown-item use-router to="/scankanban/En Stock">En stock</b-dropdown-item>
      </b-dropdown-group>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-group id="dropdown-group-2" header="Boucle Interne">
        <b-dropdown-item use-router to="/scankanban/En Préparation">En Préparation</b-dropdown-item>
        <b-dropdown-item use-router to="/scankanban/Cellule 1">Cellule 1</b-dropdown-item>
        <b-dropdown-item use-router to="/scankanban/Cellule 2">Cellule 2</b-dropdown-item>
        <b-dropdown-item use-router to="/scankanban/Cellule 3">Cellule 3</b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown
      id="dropdown-catalogue"
      text="References"
      toggle-class="nav-link-custom"
      right>
      <b-dropdown-group id="dropdown-group-1" header="Boucle externe">
          <b-dropdown-item use-router :to="{name: 'external_references'}">Références</b-dropdown-item>
          <b-dropdown-item use-router :to="{name: 'external_cards'}">Cartes Kanban</b-dropdown-item>
          <b-dropdown-item use-router :to="{name: 'external_overview'}">Boucle</b-dropdown-item>
      </b-dropdown-group>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-group id="dropdown-group-1" header="Boucle interne">
          <b-dropdown-item use-router :to="{name: 'internal_references'}">Références</b-dropdown-item>
          <b-dropdown-item use-router :to="{name: 'internal_cards'}">Cartes Kanban</b-dropdown-item>
          <b-dropdown-item use-router :to="{name: 'internal_overview'}">Boucle</b-dropdown-item>
      </b-dropdown-group>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-group id="dropdown-group-1" header="Boucle trading">
          <b-dropdown-item use-router :to="{name: 'trading_references'}">Références</b-dropdown-item>
          <b-dropdown-item use-router :to="{name: 'trading_cards'}">Cartes Kanban</b-dropdown-item>
          <b-dropdown-item use-router :to="{name: 'trading_overview'}">Boucle</b-dropdown-item>
      </b-dropdown-group>
    </b-nav-item-dropdown>
    <!-- <b-nav-item use-router :to="{name: 'ranking'}" exact>Ranking</b-nav-item> -->
    <b-nav-item-dropdown
      id="dropdown-settings"
      text="Settings"
      toggle-class="nav-link-custom"
      right>
      <b-dropdown-item use-router :to="{name: 'loopOperation'}">Opération Boucles</b-dropdown-item>
    </b-nav-item-dropdown>
    <!-- <b-nav-item use-router :to="{name: 'andonatelier'}">Atelier</b-nav-item> -->
    <!-- <b-form-select v-model="selected" :options="options"></b-form-select> -->
    <b-button
      variant="outline-primary"
      style="margin-left: 30px"
      @click="goTo('/scankanbanworkstation/')">Scanner un kanban</b-button>
  </b-navbar-nav>
  
</div>
</template>
<script>


export default {
  name: 'AioNavBar',
 
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/AioNavBar.vue